import { Navigate, useLocation } from "react-router-dom";
import { restrictedUsers } from "./restrictedUsers";

const PrivateRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();

  // Not logged in
  if (!user) {
    return <Navigate to="/login" />;
  }

  const isRestrictedUser = restrictedUsers.includes(user?.email);

  // Restricted users → force Feeder (HomePage)
  if (isRestrictedUser && location.pathname !== "/HomePage") {
    return <Navigate to="/HomePage" replace />;
  }

  return children;
};

export default PrivateRoute;
